import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { request } from "@app/services";
import {
  addBrand,
  addBrandFailed,
  addBrandSuccess,
  brand,
  brandFailed,
  brandSuccess,
  deleteBrand,
  deleteBrandFailed,
  deleteBrandSuccess,
} from "./slice";
import * as endpoints from "./endpoints";
import { selectBrandState } from "./selector";
import { IBrandData } from "./types";

//--------------------GetAllBrands-------------------------

function* brandSaga(action: ReturnType<typeof brand>): any {
  try {
    const response = yield call(request.get, endpoints.brands);
    if (response?.status) {
      yield put(brandSuccess(response.data));
    }
  } catch (error: any) {
    yield put(brandFailed(error));
  }
}
//--------------------AddBrandSagas-------------------------

function* addBrandSagas(action: ReturnType<typeof addBrand>): any {
  try {
    const brand = yield select(selectBrandState);
    const { name, image, selectedBrandId } = action.payload;
    
    const formData = new FormData();
    formData.append("name", name);
    formData.append("image", image);

    if (selectedBrandId) {
      const formData = new FormData();
      formData.append("name", name);
      if (image) {
        formData.append("image", image);
      }
      const response = yield call(
        request.patch,
        `${endpoints.updateBrandById}${selectedBrandId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      yield put(addBrandSuccess(response?.data));
      if (Array.isArray(brand.data) && brand.data.length > 0) {
        const updatedBrands = brand?.data?.map((item: IBrandData) => {
          if (item.id === selectedBrandId) {
            return {
              ...item,
              image: response?.data?.image,
              name: response?.data?.name,
            };
          } else {
            return item;
          }
        });
        yield put(brandSuccess(updatedBrands));
      }
    } else {
      const response = yield call(request.post, endpoints.addBrands, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response?.status) {
        yield put(addBrandSuccess(response?.data));
        if (Array.isArray(brand.data)) {
          const newBrands = [...brand.data, response.data];
          yield put(brandSuccess(newBrands));
        }
      }
    }
  } catch (error: any) {
    yield put(addBrandFailed(error));
  }
}

function* deleteBrandSagas(action: ReturnType<typeof deleteBrand>): any {
  try {
    const { brandId } = action.payload;
    const brands = yield select(selectBrandState);
    const response = yield call(
      request.delete,
      `${endpoints.deleteBrandById}${brandId}`
    );
    yield put(deleteBrandSuccess(response?.message));
    if (Array.isArray(brands?.data) && brands?.data?.length > 0) {
      const newBrands = brands?.data?.filter(
        (item: { id: number }) => item.id !== brandId
      );
      yield put(brandSuccess(newBrands));
    }
  } catch (err: any) {
    yield put(deleteBrandFailed(err));
  }
}

function* brandSagas() {
  yield all([takeLatest(brand, brandSaga)]);
  yield all([takeLatest(addBrand, addBrandSagas)]);
  yield all([takeLatest(deleteBrand, deleteBrandSagas)]);
}

export { brandSagas };
